import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { GlobalService } from 'src/app/_services/global.service';
import { UserService } from 'src/app/_services/user.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {
  resetForm: UntypedFormGroup;
  token;
  resetSucces = false;
  passwordType = 'password';
  passwordConfirmationType = 'password';
  passwordMismatch = false;
  userNotExist = false;
  currLang;
  constructor(private router: Router, private userService: UserService, private activatedRoute: ActivatedRoute, private global: GlobalService, private translate: TranslateService) { }

  ngOnInit(): void {
    this.global.getLang().subscribe(lng => {
      this.currLang = lng;
      this.global.setLang(this.currLang);
      this.activatedRoute.queryParams.subscribe(params => {
        this.token = params.reset_token;
      })
    })
    this.resetForm = new UntypedFormGroup({
      email: new UntypedFormControl('', [Validators.required, Validators.email, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$')]),
      password: new UntypedFormControl('', [Validators.required,
      Validators.minLength(8),
      Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!\“#$%&‘()*+,-./:;<=>?@\[\\\]^_`{|}~ ]).{8,}$')]),
      password_confirmation: new UntypedFormControl('', [Validators.required,
      Validators.minLength(8),
      Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!\“#$%&‘()*+,-./:;<=>?@\[\\\]^_`{|}~ ]).{8,}$')]),
    })
  }

  getValidationMessage(control: string) {
    let errorMsg;
    if (this.resetForm.controls[control].errors) {
      errorMsg =
        this.resetForm.controls[control].errors.required ?
          this.translate.instant(`reset-password.${control}-required`) :
          this.resetForm.controls[control].errors.minlength ? this.translate.instant(`reset-password.${control}-length`) :
            this.userNotExist ? this.translate.instant('reset-password.wrong-email') : this.translate.instant(`reset-password.${control}-error`);
    }

    if (this.resetForm.value['password'] != this.resetForm.value['password_confirmation']
      && this.resetForm.value['password']?.length >= 8 && this.resetForm.value['password_confirmation']?.length >= 8) {
      this.resetForm.controls['password_confirmation'].setErrors({ incorrect: true });
      this.resetForm.controls['password_confirmation'].markAsTouched();
      errorMsg = this.translate.instant('reset-password.password-mismatch')
    }
    return errorMsg;
  }

  resetPassword() {
    let body = {};
    this.userNotExist = false;
    for (const key in this.resetForm.value) {
      body[key] = this.resetForm.value[key]
    }
    body['token'] = this.token;
    this.userService.resetPassword(body).subscribe(res => {
      this.resetSucces = true;
    }, error => {
      this.resetSucces = false;
      this.userNotExist = true;
      this.resetForm.controls['email'].setErrors({ 'incorrect': true });
      this.resetForm.controls['email'].markAsTouched();
    })
  }

  clearPasswordConfirmation() {
    this.resetForm.controls['password_confirmation'].reset();
  }

  goToLogin() {
    this.router.navigateByUrl('login');
  }

  togglePassword() {
    this.passwordType = this.passwordType === 'text' ? 'password' : 'text';
  }

  togglePasswordConfirmation() {
    this.passwordConfirmationType = this.passwordConfirmationType === 'text' ? 'password' : 'text';
  }

}
